<template>
<el-dialog
  :visible='true'
  title='创建模板'
  :before-close='handleClose'
  width='1100px'
  :close-on-click-modal='false'
>
<div style="display: flex;" v-loading="loading">
  <div class="form">
    <el-form label-width="120px" size="small">
      <el-form-item required label="模板名称：">
        <el-input 
          size="small" 
          style="width: 350px;"
          v-model="form.name" 
          placeholder=""
          maxlength="15" 
          show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item required label="模板类型：">
        <el-radio-group v-model="form.type">
            <el-radio :label="1">图文单卡片</el-radio>
            <el-radio :label="2">视频单卡片</el-radio>
            <el-radio :label="3">图片轮播卡片</el-radio>
            <el-radio :label="4">红包卡片</el-radio>
            <el-radio :label="5">商品卡片</el-radio>
          </el-radio-group>
      </el-form-item>
      <template v-if="form.type == 1">
        <el-form-item required  label="模板图片：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{smsCardFileList.length}}/{{sourceMax}}）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item required  label="卡片标题：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form1.title" 
            placeholder=""
            maxlength="17" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="正文内容：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form1.text" 
            placeholder=""
            :maxlength="textLimit" 
           >
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入{{textLength}}个字（含签名及退订文字）</div>
          </div>
        </el-form-item>
        <el-form-item required  label="按钮名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form1.btnConfig.btnArray[0].btnName"
            placeholder=""
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="按钮链接：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form1.btnConfig.btnArray[0].url"
            placeholder=""
            readonly>
          </el-input>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(0)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
        <el-form-item required  label="原始短信：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form1.sms"
            :maxlength="smsLimit"
            placeholder="">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入<span style="color:#278cfe">{{smsLength}}/69</span>个字（含签名及退订文字）</div>
            <div class="sms-icon">
              <el-tooltip 
                class="item"
                effect="light"
                placement="top-start">
                <div slot="content">
                  (1)原始短信用于"显示原文"时展示使用，因运营商限制，原始短信字数最多69字；<br/>
                  (2)文本内容插入的短链会用变量标签#自定义短链接#代替，实际显示时会转换成短链显示；<br/>
                  (3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(2)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
      </template>
      <template v-else-if="form.type == 2">
        <el-form-item required  label="模板图片：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{smsCardFileList.length}}/{{sourceMax}}）</el-button>
          <el-button @click="openSelectSource(1)" class="button-status5" style="width: unset;">选择封面素材（{{smsCardCoverFileList.length}}/1）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item required  label="卡片标题：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form2.title" 
            placeholder=""
            maxlength="17" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="正文内容：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form2.text" 
            placeholder=""
            :maxlength="textLimit" 
           >
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入{{textLength}}个字（含签名及退订文字）</div>
          </div>
        </el-form-item>
        <el-form-item required  label="按钮名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form2.btnConfig.btnArray[0].btnName"
            placeholder=""
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="按钮链接：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form2.btnConfig.btnArray[0].url"
            placeholder=""
            readonly>
          </el-input>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(0)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
        <el-form-item required  label="原始短信：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;"
            v-model="form2.sms"
            :maxlength="smsLimit"
            placeholder="">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入<span style="color:#278cfe">{{smsLength}}/69</span>个字（含签名及退订文字）</div>
            <div class="sms-icon">
              <el-tooltip 
                class="item"
                effect="light"
                placement="top-start">
                <div slot="content">
                  (1)原始短信用于"显示原文"时展示使用，因运营商限制，原始短信字数最多69字；<br/>
                  (2)文本内容插入的短链会用变量标签#自定义短链接#代替，实际显示时会转换成短链显示；<br/>
                  (3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(2)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
      </template>
      <template v-else-if="form.type == 3">
        <el-form-item required  label="模板图片：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{smsCardFileList.length}}/{{sourceMax}}）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item required  label="卡片标题：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form3.title" 
            placeholder=""
            maxlength="17" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="正文内容：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form3.text" 
            placeholder=""
            :maxlength="textLimit" 
           >
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入{{textLength}}个字（含签名及退订文字）</div>
          </div>
        </el-form-item>
        <el-form-item required  label="按钮名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form3.btnConfig.btnArray[0].btnName"
            placeholder=""
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="按钮链接：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form3.btnConfig.btnArray[0].url"
            placeholder=""
            readonly>
          </el-input>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(0)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
        <el-form-item required  label="原始短信：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form3.sms"
            :maxlength="smsLimit"
            placeholder="">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入<span style="color:#278cfe">{{smsLength}}/69</span>个字（含签名及退订文字）</div>
            <div class="sms-icon">
              <el-tooltip 
                class="item"
                effect="light"
                placement="top-start">
                <div slot="content">
                  (1)原始短信用于"显示原文"时展示使用，因运营商限制，原始短信字数最多69字；<br/>
                  (2)文本内容插入的短链会用变量标签#自定义短链接#代替，实际显示时会转换成短链显示；<br/>
                  (3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(2)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
      </template>
      <template v-else-if="form.type == 4">
        <el-form-item required  label="模板图片：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{smsCardFileList.length}}/{{sourceMax}}）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item required  label="红包名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form4.redName" 
            placeholder=""
            maxlength="18" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="卡片标题：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form4.title" 
            placeholder=""
            maxlength="11" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="正文内容：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form4.text" 
            placeholder=""
            :maxlength="textLimit">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入{{textLength}}个字（含签名及退订文字）</div>
          </div>
        </el-form-item>
        <el-form-item required  label="按钮名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form4.btnConfig.btnArray[0].btnName"
            placeholder=""
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="按钮链接：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form4.btnConfig.btnArray[0].url"
            placeholder=""
            readonly>
          </el-input>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(0)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
        <el-form-item required  label="原始短信：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form4.sms"
            :maxlength="smsLimit"
            placeholder="">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入<span style="color:#278cfe">{{smsLength}}/69</span>个字（含签名及退订文字）</div>
            <div class="sms-icon">
              <el-tooltip 
                class="item"
                effect="light"
                placement="top-start">
                <div slot="content">
                  (1)原始短信用于"显示原文"时展示使用，因运营商限制，原始短信字数最多69字；<br/>
                  (2)文本内容插入的短链会用变量标签#自定义短链接#代替，实际显示时会转换成短链显示；<br/>
                  (3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(2)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
      </template>
      <template v-else-if="form.type == 5">
        <el-form-item required  label="图片/视频：">
          <el-radio-group v-model="form5.goodsCard">
            <el-radio :label="1">图文</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form5.goodsCard == 1" required label="模板图片：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{form5.prePicUrl.length}}/{{sourceMax}}）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item v-else required label="模板视频：">
          <el-button @click="openSelectSource" class="button-status5" style="width: unset;">选择素材（{{form5.preVideoUrl ? '1' : '0'}}/{{sourceMax}}）</el-button>
          <el-button @click="openSelectSource(1)" class="button-status5" style="width: unset;">选择封面素材（{{smsCardCoverFileList.length}}/1）</el-button>
          <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardSource">添加素材</span>
        </el-form-item>
        <el-form-item required  label="价格：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form5.price" 
            placeholder=""
            maxlength="12" 
            show-word-limit>
          </el-input>
          <el-checkbox style="margin-left: 8px;" :true-label="1" :false-label="0" v-model="form5.displaySymbol">显示符号￥</el-checkbox>
        </el-form-item>
        <el-form-item required  label="标签：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form5.label" 
            placeholder=""
            maxlength="12" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="卡片标题：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form5.title" 
            placeholder=""
            maxlength="17" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="正文内容：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form5.text" 
            placeholder=""
            :maxlength="textLimit" 
          >
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入{{textLength}}个字（含签名及退订文字）</div>
          </div>
        </el-form-item>
        <el-form-item required  label="按钮数量：">
          <el-radio-group v-model="form5.btnConfig.btnCnt" @change="changeBtnCnt">
            <el-radio :label="1">一个按钮</el-radio>
            <el-radio :label="2">两个按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item required  label="按钮名称：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form5.btnConfig.btnArray[0].btnName"
            placeholder=""
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item required  label="按钮链接：">
          <el-input 
            size="small" 
            style="width: 350px;"
            v-model="form5.btnConfig.btnArray[0].url"
            placeholder=""
            readonly>
          </el-input>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(0)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item> -->
        <template v-for="(item,index) in form5.btnConfig.btnArray">
          <el-form-item required  label="按钮名称：">
            <el-input 
              size="small" 
              style="width: 350px;"
              v-model="item.btnName"
              placeholder=""
              maxlength="15" 
              show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item required  label="按钮链接：">
            <el-input 
              size="small" 
              style="width: 350px;"
              v-model="item.url"
              placeholder=""
              readonly>
            </el-input>
          </el-form-item>
          <el-form-item required  label="辅助工具：">
            <div class="tool">
              <p @click.prevent="handleShowShortLink(index)">
                <i class="iconfont iconbtn_duanwangzhi"></i>
                插入短网址
              </p>
            </div>
          </el-form-item>
        </template>
        <el-form-item required  label="原始短信：">
          <el-input 
            size="small" 
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            style="width: 350px;border-radius: 4px 4px 0 0;"
            v-model="form5.sms"
            :maxlength="smsLimit" 
            placeholder="">
          </el-input>
          <div class="sms-tip">
            <div class="sms-length">已输入<span style="color:#278cfe">{{smsLength}}/69</span>个字（含签名及退订文字）</div>
            <div class="sms-icon">
              <el-tooltip 
                class="item"
                effect="light"
                placement="top-start">
                <div slot="content">
                  (1)原始短信用于"显示原文"时展示使用，因运营商限制，原始短信字数最多69字；<br/>
                  (2)文本内容插入的短链会用变量标签#自定义短链接#代替，实际显示时会转换成短链显示；<br/>
                  (3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
        <el-form-item required  label="辅助工具：">
          <div class="tool">
            <p @click.prevent="handleShowShortLink(2)">
              <i class="iconfont iconbtn_duanwangzhi"></i>
              插入短网址
            </p>
          </div>
        </el-form-item>
      </template>
      <el-form-item label="短信签名:">
          <div class="btnList">
            <div class="btnBox" v-for="(item, index) in suffixList" :key="'label' + index"
               style="margin-bottom:5px">
              <div class="btn" style="line-height: 20px;">{{ item }}</div>
              <span class="check" v-if="smsSuffix === item">
                <i class="el-icon-check"></i>
              </span>
            </div>
            <span style="font-size: 14px; cursor: pointer" class="btnListButtom" @click="replaceSignature">更换</span>
          </div>
        </el-form-item>
    </el-form>
  </div>
  <div style="margin-left: 50px;">
    <div style="display: flex;align-items: center;margin-bottom: 16px;">
      <img src="@/assets/images/tip.png" width="14" height="14"/>
      &nbsp;<span class="tips" @click="handleShowTip">模板示例</span>
    </div>
    <div
      class="mobile-box"
      :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
    >
      <div class="sms-center">
        <div v-if="form.type == 1">
          <el-image v-if="form1.preUrl" :preview-src-list="[form1.preUrl]"  :src="form1.preUrl" alt="" width="216" :z-index="9999"></el-image>
          <div class="bggray">
            <div class="title">{{ form1.title }}</div>
            <div class="content">{{ form1.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form1.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 2">
          <video
            style="max-width: 216px; border-radius: 6px 6px 0 0"
            controlslist="nodownload"
            ref="curVideo"
            preload="auto"
            controls="controls"
            :key="form2.preUrl + 'form2'"
            v-if="form2.preUrl"
          >
            <source  :src="form2.preUrl" type="video/mp4" />
          </video>
          <div class="bggray">
            <div class="title">{{ form2.title }}</div>
            <div class="content">{{ form2.text }}</div>
            <div class="btn">{{ form2.btnConfig.btnArray[0].btnName }}</div>
          </div>
        </div>
        <div v-else-if="form.type == 3">
          <div class="card-carousel" style="width: 218px;height: 122px;">
            <el-carousel height="122px" indicator-position="none" arrow="never" :interval="1000">
              <el-carousel-item v-for="(item, index) in form3.preUrl" :key="'mulitiFileList'+index">
                <el-image 
                  style="width: 100%; height: 100%" 
                  :src="item" 
                  :preview-src-list="form3.preUrl" 
                  :initial-index="index"
                  :fit="'cover'"
                  :z-index="99999">
              </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="bggray">
            <div class="title">{{ form3.title }}</div>
            <div class="content">{{ form3.text }}</div>
            <div class="btn">{{ form3.btnConfig.btnArray[0].btnName }}</div>
          </div>
        </div>
        <div v-else-if="form.type == 4">
          <div class="redEnvelope">
            <el-image v-if="form4.preUrl" class="packetIcon" :src="form4.preUrl" :preview-src-list="[form4.preUrl]"
              :z-index="99999">
            </el-image>
            <div class="packetText">
              <div class="redNameText">{{  form4.redName }}</div>
              <div class="editText" style="font-size: 16px;">
                {{ form4.title }}
              </div>
              <div class="describeText">
                {{ form4.text }}
              </div>
            </div>
            <div class="btn-list" style="position: absolute;bottom: 24px; left: 0; right: 0; margin: auto;">
              <div class="btn">{{ form4.btnConfig.btnArray[0].btnName }}</div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 5">
          <div v-if="form5.goodsCard == 1" class="card-carousel" style="width: 218px;height: 122px;">
            <el-carousel height="122px" indicator-position="none" arrow="never" :interval="1000">
              <el-carousel-item v-for="(item, index) in form5.prePicUrl" :key="'mulitiFileList'+index">
                <el-image 
                  style="width: 100%; height: 100%" 
                  :src="item" 
                  :preview-src-list="form5.prePicUrl" 
                  :initial-index="index"
                  :fit="'cover'"
                  :z-index="99999">
              </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <video
            style="max-width: 216px; border-radius: 6px 6px 0 0"
            controlslist="nodownload"
            ref="curVideo"
            preload="auto"
            controls="controls"
            :key="form5.preVideoUrl + 'form5'"
            v-if="form5.goodsCard == 2 && form5.preVideoUrl"
          >
            <source :src="form5.preVideoUrl" type="video/mp4" />
          </video>
          <div class="bggray">
            <div class="price-box">
              <div class="price">
                <span v-if="form5.displaySymbol == 1">￥</span>
                <span>{{ form5.price }}</span>
              </div>
              <div class="label" v-if="form5.label">{{ form5.label }}</div>
            </div>
            <div class="title">{{ form5.title }}</div>
            <div class="content">{{ form5.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form5.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 插入短链接 -->
  <insert-short-dialog v-if="insertShortUrlShow" @close="handleCloseShort"></insert-short-dialog>
  <tip-dialog v-if="showTip" :type="form.type" @close="handleCloseTip"></tip-dialog>
  <select-source 
    v-if="selectSourceShow" 
    :type="sourceType"
    :ids="smsCardFileList"
    :max="sourceMax"
    @close="selectSourceShow = false"
    @confirm="handleSelectSource"></select-source>
</div>
<template #footer>
  <div class='dialog-bottom'>
    <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
    <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
  </div>
</template>
</el-dialog>
</template>

<script>
import insertShortDialog from "@/components/insert-short-dialog";
import tipDialog from "./tipDialog.vue";
import selectSource from "./selectSource.vue";

import { saveCard,getCardDetail } from '@/api/backstage/smsCard'
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
export default {
 name: '' ,
 components: {
  insertShortDialog,
  tipDialog,
  selectSource
 },
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  id:{
    type: String | Number,
    default: null,
  }
 },
 data() {
  return {
    loading:false,
    suffixList:[],
    smsSuffix:'',
    TTip:'拒收请回复R',
    selectSourceShow:false,
    showTip:false,
    insertShortUrlShow: false, // 短链弹窗
    mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
    form:{
      name: "",
      type: 1, 
    },
    form1:{
      smsCardFileId: "",
      title: "",
      text: "",
      btnConfig: {
        btnCnt: 1,
        btnArray: [
          {
            btnName: "",
            url: "",
          },
        ],
      },
      originUrl: "",
      sms:"",
      preUrl:"",
    },
    
    form2:{
      smsCardFileId: "",
      coverId: "",
      title: "",
      text: "",
      btnConfig: {
        btnCnt: 1,
        btnArray: [
          {
            btnName: "",
            url: "",
          },
        ],
      },
      originUrl: "",
      sms:"",
      preUrl:"",
    },
    form3:{
      smsCardFileId: "",
      title: "",
      text: "",
      btnConfig: {
        btnCnt: 1,
        btnArray: [
          {
            btnName: "",
            url: "",
          },
        ],
      },
      originUrl: "",
      sms:"",
      preUrl:[],
    },
    form4:{
      smsCardFileId: "",
      redName:"",
      title: "",
      text: "",
      btnConfig: {
        btnCnt: 1,
        btnArray: [
          {
            btnName: "",
            url: "",
          },
        ],
      },
      originUrl: "",
      sms:"",
      preUrl:"",
    },
    form5:{
      goodsCard:1,
      smsCardFileId: "",
      coverId: "",
      price:"",
      displaySymbol:0,
      label:"",
      title: "",
      text: "",
      btnConfig: {
        btnCnt: 1,
        btnArray: [
          {
            btnName: "",
            url: "",
          },
        ],
      },
      originUrl: "",
      sms:"",
      prePicUrl:[],
      preVideoUrl:"",
    },
    urlNum:1,
    isCover:false,
    // url1:"",
    // url2:"",
    // urlList3:[],
    // url4:"",
    // url5:"",
    // urlList5:[],
  }
 },
 computed: {
  smsCardFileList(){
    if(this[`form${this.form.type}`].smsCardFileId){
      return this[`form${this.form.type}`].smsCardFileId.split(",");
    }else{
      return []
    }
  },
  smsCardCoverFileList(){
    if(this[`form${this.form.type}`].coverId){
      let coverId = String(this[`form${this.form.type}`].coverId)
      return coverId.split(",");
    }else{
      return []
    }
  },
  sourceType(){
    if(this.form.type == 1){
      return 1
    }else if(this.form.type == 2){
      if(this.isCover){
        return 1
      }
      return 2
    }else if(this.form.type == 3){
      return 1
    }else if(this.form.type == 4){
      return 1
    }else if(this.form.type == 5 && this.form5.goodsCard == 1){
      return 1
    }else if(this.form.type == 5 && this.form5.goodsCard == 2){
      if(this.isCover){
        return 1
      }
      return 2
    }
  },
  sourceMax(){
    if(this.form.type == 1){
      return 1
    }else if(this.form.type == 2){
      return 1
    }else if(this.form.type == 3){
      return 5
    }else if(this.form.type == 4){
      return 1
    }else if(this.form.type == 5 && this.form5.goodsCard == 1){
      return 8
    }else if(this.form.type == 5 && this.form5.goodsCard == 2){
      return 1
    }
  },
  hasUrl(){
    let text = this[`form${this.form.type}`].sms
    return text.match('#自定义短链接#')
  },
  smsLength(){
    let sourceUrlNumber = 0
    if(this[`form${this.form.type}`].originUrl.indexOf('item.m.jd.com')!==-1||this[`form${this.form.type}`].originUrl.indexOf('shop.m.jd.com')!==-1||this[`form${this.form.type}`].originUrl.indexOf('shopmember.m.jd.com')!==-1){
      sourceUrlNumber = 2
    }
    let add = this.hasUrl ? 7 + sourceUrlNumber : 0
    return this[`form${this.form.type}`].sms.length + add + this.TTip.length + this.smsSuffix.length + 2
  },
  smsLimit(){
    let sourceUrlNumber = 0
    if(this[`form${this.form.type}`].originUrl.indexOf('item.m.jd.com')!==-1||this[`form${this.form.type}`].originUrl.indexOf('shop.m.jd.com')!==-1||this[`form${this.form.type}`].originUrl.indexOf('shopmember.m.jd.com')!==-1){
      sourceUrlNumber = 2
    }
    let add = this.hasUrl ? 7 + sourceUrlNumber : 0
    return 450 - add - this.TTip.length - this.smsSuffix.length - 2
  },
  textLength(){
    return this[`form${this.form.type}`].text.length + this.TTip.length + this.smsSuffix.length + 2
  },
  textLimit(){
    return 69 - this.TTip.length - this.smsSuffix.length - 2
  }
 },
 created() {
 
 },
 mounted() {
  this.getOfficialSuffix();
  if(this.id){
    this.loading = true;
    getCardDetail(this.id).then(res=>{
      this.loading = false;
      if(res.code == 1){
        let data = res.data
        let text = this.clipTrailingString(data.text,this.TTip)
        let sms = this.clipTrailingString(data.sms,this.TTip)
        data.text = text;
        data.sms = sms;
        this.form.type = data.type
        this.form.name = data.name
        Object.keys(this[`form${this.form.type}`]).map(key=>{
          if(data[key]){
             this[`form${this.form.type}`][key] = data[key]
          }
         
        })
        if(data.type == 1){
          this.form1.preUrl = data.mulitiFileList[0].mulitiFileDatas.fileUrl
        }else if(data.type == 2){
          this.form2.preUrl = data.mulitiFileList[0].mulitiFileDatas.fileUrl
        }else if(data.type == 3){
          this.form3.preUrl = data.mulitiFileList.map(item=>{
            return item.mulitiFileDatas.fileUrl
          })
        }else if(data.type == 4){
          this.form4.preUrl = data.mulitiFileList[0].mulitiFileDatas.fileUrl
        }else if(data.type == 5){
          if(this.form5.goodsCard == 1){
            this.form5.prePicUrl = data.mulitiFileList.map(item=>{
              return item.mulitiFileDatas.fileUrl
            })
          }else{
            this.form5.preVideoUrl = data.mulitiFileList[0].mulitiFileDatas.fileUrl
          }
        }
      }else{
        this.$message.error(res.message)
      }
    })
  }
 },
 methods: {
  clipTrailingString(str, trailing) {
    const regex = new RegExp(trailing + '$');
    return str.replace(regex, '');
  },
  // 获取官方的短信签名
  getOfficialSuffix() {
    getPrecisionJdSuffixList(2).then((res) => {
      this.suffixList = res && res.data;
      this.smsSuffix = res && res.data[0];
    });
  },
  switchSuffix(item) {
    this.smsSuffix = item;
  },
  //更换签名
  replaceSignature() {
    let routeUrl = this.$router.resolve({
      path: "/backstage/signature_management/signature_report_official",
    });
    window.open(routeUrl.href, "_blank");
  },
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    let {preUrl,prePicUrl,preVideoUrl,...query} = this[`form${this.form.type}`];
    let params = {...this.form,...query};
    params.sms += this.TTip
    params.text += this.TTip
    saveCard(params).then(res=>{
      console.log('res',res);
      if(res.code == 1){
        this.$message.success('创建成功');
        this.$emit('confirm');
      }else{
        this.$message.warning(res.message);
      }
      
    })
   
  },
  openSelectSource(val){
    if(val == 1){
      this.isCover = true;
    }else{
      this.isCover = false;
    }
    this.selectSourceShow = true;
  },
  handleSelectSource(obj){
    if(this.isCover){
      this[`form${this.form.type}`].coverId = obj.ids.join(',')
    }else{
      this[`form${this.form.type}`].smsCardFileId = obj.ids.join(',')
      if(this.form.type == 5){
        if(this.form5.goodsCard == 1){
          this.form5.prePicUrl = obj.urlList
        }else{
          this.form5.preVideoUrl = obj.urlList
        }
      }else{
        // this[`form${this.form.type}`].smsCardFileId = obj.ids.join(',')
        this[`form${this.form.type}`].preUrl = obj.urlList
      }
      
    }
    console.log('handleSelectSource',obj);
    this.selectSourceShow = false;
  },
  addCardSource(){
    let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "7" },
      });
      window.open(routeUrl.href, "_blank");
  },
  // 显示短链弹窗
  handleShowShortLink(num) {
      this.urlNum = num;
      this.insertShortUrlShow = true;
    },
  // 关闭短链接
  handleCloseShort(val, obj) {
    this.insertShortUrlShow = false;
    if (val) {
      if(this.urlNum != 2){
        this[`form${this.form.type}`].btnConfig.btnArray[this.urlNum].url = obj.originUrl
      }else{
        let text = this[`form${this.form.type}`].sms
        
        if (text.length >= 435) {
          this.$message.warning("短信内容过多，请先删减");
          return
        }
        if (text.match('#自定义短链接#')) {
        }else{  
          this[`form${this.form.type}`].sms += '#自定义短链接#'
        }
        this[`form${this.form.type}`].originUrl = obj.originUrl
      } 
    }
  },

  // 
  handleShowTip(){
    this.showTip = true;
  },
  handleCloseTip(){
    this.showTip = false;
  },

  changeBtnCnt(){
    if(this.form5.btnConfig.btnCnt == 2){
      this.form5.btnConfig.btnArray.push({
        btnName: "",
        url: "",
      })
    }else{
      this.form5.btnConfig.btnArray.pop()
    }
  }
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}

.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;
  
  .sms-center {
    overflow: auto;
    // width: 244px;
    height: 335px;
    padding: 0 20px;
    position: relative;
    top: 93px;
    left: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .bggray {
    background: #f5f5f5;
    border-radius: 0px 0px 6px 6px;
    padding: 10px 8px 12px 8px;
    .title {
      height: 17px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 22px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .content {
      font-weight: 400;
      font-size: 10px;
      color: #999999;
      line-height: 16px;
      margin: 10px 0;
    }
    .price-box{
      display: flex;
      margin-bottom: 10px;
      .price{
        font-weight: 400;
        font-size: 12px;
        color: #FE4D45;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .label{
        margin-left: 6px;
        padding: 0 4px;
        background: #FE4D45;
        border-radius: 2px 2px 2px 2px;
        font-weight: 400;
        font-size: 10px;
        color: #FFFFFF;
        line-height: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .btn-box{
      display: flex;
      .btn{
        flex: 1;
        height: 24px;
        padding: 0;
        line-height: 22px;
        background: #278CFE;
        border-radius: 2px 2px 2px 2px;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
      }
      .btn + .btn{
        margin-left: 10px;
      }
    }
  }
  .title {
    height: 17px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .content {
    font-weight: 400;
    font-size: 10px;
    color: #999999;
    line-height: 16px;
    margin: 10px 0;
  }
  .btn {
    background: #278cfe;
    border-radius: 2px 2px 2px 2px;
    text-align: center;
    height: 24px;
    color: #ffffff;
    line-height: 24px;
    font-size: 10px;
  }
}

.button-status5 {
  background-color: #fff;
  border: 1px solid #fe4d45;
  font-size: 14px;
  color: #fe4d45;

  &:hover {
    background-color: #fe4d45;
    border: 1px solid #fe4d45;
    color: #fff;
  }

  &:active {
    background-color: #fe4d45;
    border: #fe4d45;
    color: #fff;
  }
}
.tips{
  font-size: 14px;
  color: #7F85E9;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  text-transform: none;
  cursor: pointer;
}
.tool {
  cursor: pointer;
  display: flex;
  align-items: center;

  p {
    box-sizing: border-box;
    padding: 0 8px !important;
    margin: 0 8px 0 0 !important;
    // width: 98px;
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px;
    border-radius: 3px;
    background-color: #FFF6F6;
    color: #FE4D45 !important;

    &:hover {
      background: #ffececab;
      color: #FE4D45 !important;
    }

    &:active {
      background: #ffececab;
      color: #FE4D45;
    }
  }
}
.btnListButtom {
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }

  .redEnvelope{
  width: 218px;
  height: 280px;
  background: url('~@/assets/images/backstage/redBag.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .packetIcon{
    width: 52px;
    height: 52px;
    position: absolute;
    left: 85px;
    top: 55px;
    border-radius: 50%;
  }
  .packetText {
    position: absolute;
    color: white;
    width: 100%;
    text-align: center;
    top: 120px;
  }
  .btn {
    width: 142px;
    height: 24px;
    background: #FBA704;
    border-radius: 2px 2px 2px 2px;
    font-weight: 400;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
  }

}
.redEnvelope .packetText .redNameText{
  font-size: 12px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}
.redEnvelope .packetText .editText{
  font-size: 14px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}
.redEnvelope .packetText .describeText{
  font-size: 10px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}
.el-textarea .el-input__count{
  background-color: transparent;
}
.sms-tip{
  display: flex;
  width: 350px;
  background-color: #FFFAEE;
  border: 1px solid #FFFAEE;
  .sms-length{
    flex: 1;
    margin-left: 8px;
  }
  .sms-icon{
    margin-right: 8px;
  }
  .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;
      cursor: pointer;
      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }
}
.btnList {
      display: flex;
      align-items: center;
      height: 32px;

      button {
        border: none;
        background-color: white;
        outline: none;
        padding: 0;
        margin: 0;
        border-radius: 2px;
        cursor: pointer;
      }

      .btnListButtom {
        color: rgb(127, 133, 233);

        &:hover {
          color: #fe4d45;
        }
      }

      .btnBox {
        position: relative;
        overflow: hidden;
        height: 31px;
        margin-right: 16px;

        .btn {
          padding: 5px 12px;
          height: 31px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          cursor: pointer;
        }

        .check {
          position: absolute;
          right: -16px;
          bottom: -15px;
          width: 30px;
          height: 30px;
          background-color: #fe4d45;
          border-radius: 50%;
        }

        i {
          position: absolute;
          right: 16px;
          bottom: 15px;
          font-size: 10px;
          color: #fff;
        }
      }
    }
</style>
<style lang='scss'>
.el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}

</style>